import { AlertTypesEnum } from '../enums';

export interface SafeRouteDeviationAlertMetadata {
    distanceFromRoute: number;
    firstDeviationPoint: { latitude: number; longitude: number };
    duration?: number;
}

export type AlertMetadataMap = {
    [AlertTypesEnum.SAFE_ROUTE_DEVIATION]: SafeRouteDeviationAlertMetadata;
    [AlertTypesEnum.DELAY]: Record<string, unknown>;
};

export type AlertMetadata = AlertMetadataMap[keyof AlertMetadataMap];
